<template>
  <v-layout>
    <v-flex>
      <v-card class="pa-6 pt-4 mt-10">
        <v-card-title>
          Container
        </v-card-title>

        <v-card-text class="text--primary">
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="4">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>
                      mdi-cube-outline
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>{{name}}</v-list-item-title>
                    <v-list-item-subtitle>Name</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

              </v-list>
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <!-- <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>{{date_created | moment("MMM D, YYYY")}}</v-list-item-title>
                    <v-list-item-subtitle>Date</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

              </v-list> -->
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-content>
                    <v-text-field
                      v-model="search"
                      class="table-search"
                      append-icon="mdi-magnify"
                      label="Search"
                      hide-details>
                    </v-text-field>
                  </v-list-item-content>
                </v-list-item>

              </v-list>

            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="containers"
          :loading="loading"
          :search="search"
          loading-text="Loading Containers..."
          item-key="id"
          item-id="booking_item_id"
          :items-per-page="1000"
          hide-default-footer
          show-select
          no-data-text="No Containers Found"
          ref="table">

          <template v-slot:[`item.shipping_mark`]="{ item }">
            <div class="d-flex align-center">
              <v-icon
                size="24"
                class="mr-2">
                {{ isShipmentForSea(item.shipment_type) ? 'mdi-ferry' : 'mdi-airplane' }}
              </v-icon>
              {{ item.shipping_mark }}
            </div>
          </template>

          <template v-slot:[`item.name`]="{ item }">
            {{ item.first_name + ' ' + item.last_name }}
          </template>

          <template v-slot:[`item.qty`]="{ item }">
            {{ formatNumber(item.qty) }}
          </template>

          <template v-slot:[`item.cbm`]="{ item }">
            <span>{{formatNumber(item.cbm) }}</span>
          </template>

          <template v-slot:[`item.kg`]="{ item }">
            <span>{{formatNumber(item.kg) }}</span>
          </template>

          <template v-slot:[`item.client_name`]="{ item }">
            <div class="d-flex align-center">
              <v-icon
                size="24"
                class="mr-1">
                mdi-account-outline
              </v-icon>
              {{ item.client_name }}
            </div>
          </template>

          <template v-slot:[`item.sales_agent`]="{ item }">
            <div class="d-flex align-center">
              <v-icon
                size="24"
                class="mr-1">
                mdi-face-agent
              </v-icon>

              {{ item.sales_agent }}
            </div>
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <BookingStatusLabel :status="item.status" :small="true" :statuses="statuses"></BookingStatusLabel>
            <v-tooltip bottom v-if="item.ready_for_pickup_date">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" :text="item.booking_id" color="primary" class="ml-2">mdi-truck-check</v-icon>
              </template>
              <span>Arrived in Warehouse</span>
            </v-tooltip>
            <v-icon v-else class="ml-2">mdi-truck-check</v-icon>
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom v-if="item.ready_for_pickup_date">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" :text="item.booking_id" color="primary">mdi-truck-check</v-icon>
              </template>
              <span>Arrived in Warehouse</span>
            </v-tooltip>
            <v-icon v-else>mdi-truck-check</v-icon>
          </template>

          <template v-slot:[`item.created_at`]="{ item }">
            {{ item.created_at | moment("MMM D, YYYY h:mm A") }}
          </template>
        </v-data-table>
        <v-card-actions class="ml-2 my-2 mt-6">
          <v-btn
            :disabled="hasSelected"
            color="primary"
            class="mr-1"
            depressed
            large
            @click="confirmArrivedInPort()">
            <span class="mx-4">Arrived in Port</span>
          </v-btn>

          <v-btn
            :disabled="hasSelected"
            color="primary"
            class="mr-1"
            depressed
            large
            @click="confirmArrivedInWarehouse()">
            <span class="mx-4">Arrived in Warehouse</span>
          </v-btn>
          <v-btn
            :disabled="hasSelected"
            color="primary"
            depressed
            large
            @click="confirmUpdateContainer()">
            <span class="mx-4">Update Container</span>
          </v-btn>
        </v-card-actions>
      </v-card>

      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
      <ConfirmationDialog
        :dialog="dialog"
        @doConfirm="doConfirm"
        @doCancel="doCancel"
      >
      </ConfirmationDialog>

    </v-flex>
  </v-layout>

</template>

<script>
  import { mapGetters } from "vuex";
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import BookingStatusLabel from '@/components/BookingStatusLabel.vue'
  import ConfirmationDialog from '@/components/dialog/ConfirmationDialog.vue'

  export default {
    name: 'AdminContainersPage',
    data() {
      return {
        adminNamespace: 'admin',
        date_created: '',
        name: '',
        snackbarDetails: {
          color: 'sb-success',
          msg: '',
          show: false
        },
        error:{
          show: false,
          status: '',
          error: '',
          messages: {}
        },
        dialog: {
          show: false,
          title: 'Delete Item',
          body: 'Are you sure you want to delete this item?',
          type: '',
          item: {},
          confirmBtn: 'Yes',
          cancelBtn: 'Cancel'
        },
        containers: [],
        loading: false,
        search: '',
        selected: [],
        statuses: [],
        headers: [
          {
            text: 'Shipping Mark',
            align: 'start',
            value: 'shipping_mark',
            sortable: false,
            width: 210,
          },
          {
            text: 'Container',
            value: 'container_name',
            sortable: false,
          },
          {
            text: 'Description',
            value: 'description',
            sortable: false,
          },
          {
            text: 'Qty',
            align: 'right',
            value: 'qty',
            sortable: false
          },
          {
            text: 'CBM',
            align: 'right',
            value: 'cbm',
            sortable: false
          },
          {
            text: 'KG',
            align: 'right',
            value: 'kg',
            sortable: false
          },
          {
            text: 'Sales Agent',
            align: 'start',
            value: 'sales_agent',
            sortable: false
          },
          {
            text: 'Client Name',
            align: 'start',
            value: 'client_name',
            sortable: false
          },
          {
            text: 'Status',
            align: 'center',
            value: 'status',
            sortable: false,
            width: 170,
          },
          // {
          //   text: '',
          //   align: 'center',
          //   value: 'action',
          //   sortable: false
          // }
        ]
      }
    },
    computed: {
      ...mapGetters(['getUserInitial', 'formatNumber', 'formatNumberAmount', 'forSea']),
      hasSelected: function(){
        return this.selected.length != 0 ? false : true
      }
    },
    watch: {
    },
    methods: {
      isShipmentForSea (shipment_type){
        return this.forSea(shipment_type, this)
      },
      statusColor (statusId){
        return this.getStatusColor(statusId, this)
      },
      getStatusName: function(id){
        let statuses = this.statuses.filter(status => {
          return status.id == id
        })
        if(statuses.length > 0){
          return statuses[0].name
        }
      },
      getDefaultData () {
        let self = this
        this.$http.plain.get('/default-data?booking_statuses=true')
          .then(response => {
            this.statuses = response.data.booking_statuses
          })
          .catch(error => {
            console.log(error);
          })
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      doCancel () {
        this.dialog.show = false
      },
      confirmArrivedInPort () {
        this.dialog = {
          show: true,
          title: 'Confirm Arrived In Port',
          body: 'Are you sure you want to update status of selected shipping mark(s)?',
          type: 'port',
          item: '',
          confirmBtn: 'Yes',
          cancelBtn: 'Cancel'
        }
      },
      confirmArrivedInWarehouse () {
        this.dialog = {
          show: true,
          title: 'Confirm Arrived In Warehouse',
          body: 'Are you sure you want to update status of selected shipping mark(s)?',
          type: 'warehouse',
          item: '',
          confirmBtn: 'Yes',
          cancelBtn: 'Cancel'
        }
      },
      confirmUpdateContainer () {
        this.dialog = {
          show: true,
          title: 'Confirm Update Container',
          body: 'Are you sure you want to update container of selected shipping mark(s)?',
          type: 'container',
          item: '',
          confirmBtn: 'Yes',
          cancelBtn: 'Cancel'
        }
      },
      doConfirm () {
        if (this.dialog.type === 'port') {
          this.arrivedInPort()
        } else if (this.dialog.type === 'warehouse') {
          this.arrivedInWarehouse()
        } else if (this.dialog.type === 'container') {
          this.updateContainer()
        }
      },
      arrivedInPort (){
        let selectedIds = []
        let self = this

        this.selected.forEach(obj => {
          selectedIds.push(obj.booking_item_id)
        })

        let payload = { container: this.name, bookingItems: selectedIds }

        this.$http.secured.post(this.adminNamespace+'/containers/arrived-in-port', payload)
          .then(response => {
            this.selected = []
            this.getContainer()
            this.showMessage('Booking items has been successfully updated', 'success')
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
            self.dialog.show = false
          })

      },
      arrivedInWarehouse (){
        let selectedIds = []
        let self = this

        this.selected.forEach(obj => {
          selectedIds.push(obj.booking_item_id)
        })

        let payload = { container: this.name, bookingItems: selectedIds }

        this.$http.secured.post(this.adminNamespace+'/containers/arrived-in-warehouse', payload)
          .then(response => {
            this.selected = []
            this.getContainer()
            this.showMessage('Booking items has been successfully updated', 'success')
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
            self.dialog.show = false
          })
      },
      updateContainer (){
        let selectedIds = []
        let self = this

        this.selected.forEach(obj => {
          selectedIds.push(obj.booking_item_id)
        })

        let payload = { container: this.name, bookingItems: selectedIds }

        this.$http.secured.post(this.adminNamespace+'/containers/update-container', payload)
          .then(response => {
            this.selected = []
            this.getContainer()
            this.showMessage('Booking items has been successfully updated', 'success')
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
            self.dialog.show = false
          })
      },
      getContainer () {
        if (this.loading) {
          return false
        }

        const params = {}
        if (this.search.length > 0) params.search = this.search

        this.loading = true
        let self = this
        this.$http.plain.get(`${this.adminNamespace}/containers/${this.name}`, { params: params })
          .then(response => {
            let i = 0
            response.data.forEach(obj => {
              obj.id = i
              this.containers.push(obj)
              i++
            })

            this.containers = response.data
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
        }
    },
    mounted() {
      if(this.$route.params.name){
        this.name = this.$route.params.name
      }

      this.getDefaultData()
      this.getContainer()
    },
    components: {
      SnackBar,
      BookingStatusLabel,
      ConfirmationDialog
    },
  }
</script>
